/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Locale_Heil2Inputs */

const he_locale_heil2 = /** @type {(inputs: Locale_Heil2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hebrew (Israel)`)
};

const en_locale_heil2 = /** @type {(inputs: Locale_Heil2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hebrew (Israel)`)
};

/**
* | output |
* | --- |
* | "Hebrew (Israel)" |
*
* @param {Locale_Heil2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const locale_heil2 = /** @type {((inputs?: Locale_Heil2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Locale_Heil2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_locale_heil2(inputs)
	return en_locale_heil2(inputs)
});
export { locale_heil2 as "locale_heIL" }